<template>
  <div>
    <a-drawer :title="title" :width="520" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="onClose">
      <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="上级" prop="parent_id" :help="formErr.parent_id" :validateStatus='!formErr.parent_id?"":"error"'>
          <a-select v-model="form.parent_id" placeholder="请选择上级菜单">
            <a-select-option v-for="item in menuList" :value="item.id" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="菜单名称" prop="name" :help="formErr.name" :validateStatus='!formErr.name?"":"error"'>
          <a-textarea v-model="form.name" placeholder="请输入" :rows="8" allow-clear />
        </a-form-model-item>
        <a-form-model-item label="类型" prop="component_type" :help="formErr.component_type" :validateStatus='!formErr.component_type?"":"error"'>
          <a-textarea v-model="form.component_type" :rows="8" placeholder="请输入" allow-clear/>
        </a-form-model-item>
      </a-form-model>
      <div class="drawer-btn">
        <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">确定</a-button>
        <a-button @click="onClose">取消</a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import API from "../api";

export default {
  name: "KshMenuForm",
  props: ["visible", "title", "ids", "editId"],
  data() {
    return {
      fieldNames: { label: 'name', value: 'id', children: 'children' },
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
      menuList: [],
      typeOptions: [
        { id: 1, value: 'fontSize', label: '字号' },
        { id: 2, value: 'fontFamily', label: '字体' },
        { id: 3, value: 'color', label: '颜色' },
        { id: 4, value: 'textStyle', label: '文本样式' },
        { id: 5, value: 'textAlign', label: '文本对齐' },
        { id: 6, value: 'lineHeight', label: '行高' },
        { id: 7, value: 'letterSpace', label: '字母间距' },
        { id: 8, value: 'margin', label: '外边距' },
        { id: 9, value: 'marginAndAuto', label: '外边距自适应' },
        { id: 10, value: 'brightness', label: '亮度' },
        { id: 11, value: 'zIndex', label: '层叠顺序' },
        { id: 12, value: 'padding', label: '内边距' },
        { id: 13, value: 'borderRadius', label: '圆角' },
        { id: 14, value: 'border', label: '边框' },
        { id: 15, value: 'safeWidth', label: '安全宽度' },
        { id: 16, value: 'shadow', label: '阴影' },
        { id: 17, value: 'background', label: '背景' },
        { id: 18, value: 'ratio', label: '比例' },
        { id: 19, value: 'ratio2', label: '比例2' },
        { id: 20, value: 'diffWidth', label: '一行多列适配' },
        { id: 21, value: 'diffWidth2', label: '一行多列适配2' },
        { id: 22, value: 'layoutSwitch', label: '布局切换' },
        { id: 23, value: 'colMargin', label: '列间距' },
        { id: 24, value: 'colMargin2', label: '列间距2' },
        { id: 25, value: 'rowMargin', label: '行外边距' },
        { id: 26, value: 'width', label: '宽度' },
        { id: 27, value: 'maxWidth', label: '最大宽度' },
        { id: 28, value: 'height', label: '高度' },
        { id: 29, value: 'wordMargin', label: '件模具' },
        { id: 30, value: 'colPadding', label: '列内边距' },
        { id: 31, value: 'colPadding2', label: '列内边距2' },
        { id: 32, value: 'rowGap', label: '行间距' },
        { id: 33, value: 'transformScale', label: '变换比例' },
        { id: 34, value: 'textOverflow', label: '文本溢出' },
        { id: 35, value: 'transverseMargin', label: '对齐' },
        { id: 36, value: 'transverseMargin2', label: '对齐2' },
        { id: 37, value: 'listItemLength', label: '列表项长度' },
        { id: 38, value: 'order', label: '顺序' },
        { id: 39, value: 'flexAlign', label: '弹性对齐' },
        { id: 40, value: 'floatTransverse', label: '浮动' },
        { id: 41, value: 'columsLengthOfListV2', label: '列表列个数1' },
        { id: 42, value: 'rowsLengthOfListV2', label: '列表行个数2' },
        { id: 43, value: 'gridColumns', label: '网格列数' },
        { id: 44, value: 'gapOfListV2', label: '列表间距' },
        { id: 45, value: 'imageAspectRatio', label: '图片比例' },
        { id: 46, value: 'objectFit', label: '对象适应' },
        { id: 47, value: 'textTheme', label: '文本样式' },
        { id: 48, value: 'upperLowerCase', label: '大小写转换' },
        { id: 49, value: 'transform', label: '变换' },
        { id: 50, value: 'moduleHeight', label: '模块高度' },
        { id: 51, value: 'gridSize', label: '网格大小' },
        { id: 52, value: 'textShadow', label: '文本阴影' },
        { id: 53, value: 'zoom', label: '缩放' },
        { id: 54, value: 'hollowColor', label: '描边颜色' }
      ],
      parTypeOptions: [
        { id: 1, label: '编辑', value: 'edit' },
        { id: 2, label: '上一张', value: 'pre' },
        { id: 3, label: '下一张', value: 'next' },
        { id: 4, label: '上移', value: 'upMove' },
        { id: 5, label: '下移', value: 'downMove' },
        { id: 6, label: '复制', value: 'copy' },
        { id: 7, label: '添加', value: 'add' },
        { id: 8, label: '删除', value: 'delete' },
        { id: 9, label: '显示/隐藏', value: 'isShow' },
        { id: 10, label: '翻译', value: 'translate' },
        { id: 11, label: '播放设置', value: 'playSet' },
        { id: 12, label: '属性', value: 'attribute' },
        { id: 13, label: '设计', value: 'design' },
        { id: 14, label: '划过', value: 'hover' },
        { id: 15, label: '动画', value: 'animate' },
        { id: 16, label: '链接', value: 'link' },
        { id: 17, label: '项管理', value: 'itemManage' },
        { id: 18, label: 'HTML', value: 'html' },
        { id: 19, label: 'CSS', value: 'css' },
        { id: 20, label: '样式', value: 'style' },
        { id: 21, label: '选择页面', value: 'page' },
        { id: 22, label: '联系顶部属性', value: 'contactTop' },
        { id: 23, label: '联系底部属性', value: 'contactBottom' },
        { id: 24, label: '收藏', value: 'store' },
        { id: 25, label: '裁切', value: 'clip' }
      ],
      formErr: {
        parent_id: "",
        name: "",
        component_type: ""
      },
      form: {
        id: this.editId || '',
        parent_id: '',
        name: "",
        component_type: ""
      },
      rules: {
        parent_id: [{ required: true, message: "请选择上级菜单", trigger: "change" }],
        name: [
          { required: true, message: "请输入菜单名称", trigger: "change" },
          { max: 255, message: "菜单名称不能超过255个字符", trigger: "change" }
        ],
        component_type: [
          { required: true, message: "请输入菜单类型", trigger: "change" },
          { max: 500, message: "菜单类型不能超过500个字符", trigger: "change" }
        ],
      }
    };
  },
  computed: {},
  watch: {
    ids: function (newVal) {
      if (newVal) {
        let parent_id = 0;
        this.menuList.map((item) => {
          if (item.children) {
            item.children.map((child) => {
              if (child.id === newVal) {
                parent_id = item.id;
              }
            });
          } else {
            if (item.id === newVal) {
              parent_id = item.id;
            }
          }
        });
        this.form.parent_id = parent_id
      }
    },
    editId: function (newVal) {
      if (newVal) this.form.id = newVal
    },
    visible(newVal) {
      if (newVal) {
        this.form.id = this.editId
        this.getMenuList();
      }
    },
  },
  mounted() {},
  methods: {
    getMenuList() {
      const url = this.form.id ? API.menu.KSH_MENU_EDIT_DATA(this.form.id) : API.menu.KSH_MENU_ADD_DATA()
      url.then(res => {
        this.menuList = res?.data.data['parent_list'] || []
        if(this.form.id) {
          this.form = res?.data.data['info'] || {}
        }
      })
    },
    onClose() {
      this.$emit("changVisible", false);
      this.$refs.ruleForm.resetFields();
      this.form = { parent_id: [], name: "", type: "" };
      this.formErr = { parent_id: "", name: "", type: "" };
      this.getMenuList();
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let formVal = { ...this.form }
          if (this.form.id) formVal.id = this.form.id;
          const url = this.form.id ? API.menu.KSH_MENU_EDIT : API.menu.KSH_MENU_ADD;
          url(formVal).then(res => {
            if (res.data.code === 200) {
              this.$message.success("操作成功");
              this.onClose();
            } else {
              this.$message.error("操作失败，请检查");
            }
          }).catch(() => {
            this.$message.error("操作失败，请检查");
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.drawer-btn {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  border-top: 1px solid #e8e8e8;
  background: #fff;
  text-align: right;
}
</style>